import { gql } from "@apollo/client";

const EVENT_REGISTRATION_INVITE = gql`
  query eventRegistrationInviteQuery($id: ID!) {
    eventRegistrationInvite(id: $id) {
      id
      event {
        id
        name
        profilePhoto {
          id
          filename
        }
      }
      organization {
        id
        name
        profilePhoto {
          id
          filename
        }
      }
      email
      name
      handle
      isExistingUserInvite
    }
  }
`;

export default EVENT_REGISTRATION_INVITE;
